import { useQuery } from "@tanstack/react-query";
import { ApiError } from "next/dist/server/api-utils";

export interface TokenMetadata {
  name: string;
  symbol: string;
  totalSupply: string;
  tokenType: string;
  openSeaMetadata?: {
    imageUrl?: string;
  };
  owners?: string[];
}

interface UseEtherealProps {
  chainId: number;
  contractAddress: string | null;
}

const ETHEREAL_721_FACTORY_ADDRESS =
  "0x2e3d29EDB5Af27391a65cBE6a2CeFF618D01f52E";

async function fetchTokenMetadata(chainId: number, contractAddress: string) {
  const response = await fetch(
    `/api/token-info?chainId=${chainId}&contractAddress=${contractAddress}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  const data = await response.json();

  if (response.status > 400) {
    throw new ApiError(
      response.status,
      data.message || response.statusText || "Unable to fetch token metadata",
    );
  }
  if (!response.ok) {
    throw new Error(data.error || "Failed to fetch contract data");
  }

  return data as TokenMetadata;
}

export function useTokenMetadata({
  chainId,
  contractAddress,
}: UseEtherealProps) {
  return useQuery({
    queryKey: ["token-metadata", chainId, contractAddress],
    queryFn: () => {
      if (!chainId || !contractAddress) {
        return null;
      }
      return fetchTokenMetadata(chainId, contractAddress);
    },
    retry: (res, ctx) => {
      // @ts-ignore
      return ctx.statusCode !== 404;
    },
    enabled: Boolean(chainId && contractAddress),
  });
}
